import { SyncJobsActionTypes } from './constants';

type SyncJobsAction = { type: string, payload: {} | string };

export const syncJobsApiResponseSuccess = (actionType: string, data: any): SyncJobsAction => ({
    type: SyncJobsActionTypes.API_RESPONSE_SUCCESS,
    payload: { actionType, data },
});

export const syncJobsApiResponseError = (actionType: string, error: string): SyncJobsAction => ({
    type: SyncJobsActionTypes.API_RESPONSE_ERROR,
    payload: { actionType, error },
});

export const getAllSyncJobs = (query): SyncJobsAction => ({
    type: SyncJobsActionTypes.GET_ALL_SYNC_JOBS,
    payload: { query },
});

export const resetAllSyncJobsErrors = (): SyncJobsAction => ({
    type: SyncJobsActionTypes.RESET_ALL_SYNC_JOBS_ERRORS,
    payload: {},
});
